<template>
    <Modal id="payyo-terminals-modal"
           icon="fa-solid fa-tablet"
           :title="title">
        <div v-if="errorMessage"
             class="alert alert-danger">
            <p>{{ errorMessage }}</p>
        </div>

        <PageLoadingSpinner v-if="loading"></PageLoadingSpinner>

        <div v-if="!errorMessage && !loading">
            <table class="table table-striped text-left table--valign-middle payyo-terminals-list">
                <thead>
                    <tr>
                        <th>{{ l('PAYYO_SETTINGS.DEVICE_ID__LABEL') }}</th>
                        <th>{{ l('PAYYO_SETTINGS.TERMINALS_NAME') }}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="terminal in terminals"
                        :key="terminal.lineNumber">
                        <td>{{ terminal.id }}</td>
                        <td>{{ terminal.label }}</td>
                        <td class="text-center">
                            <em v-if="terminal.id === deviceId"
                                class="no-wrap">
                                {{ l('PAYYO_SETTINGS.CURRENT_TERMINAL') }}
                            </em>
                            <button v-else
                                    class="btn btn-primary"
                                    @click="selectTerminal(terminal.id)">
                                {{ l('PAYYO_SETTINGS.TERMINALS_SELECT') }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn size="lg"
                           class="cancel-btn"
                           @click="cancel">
                    {{ l('CANCEL') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'PayyoTerminalsModal',

    components: {
        Modal,
        PageLoadingSpinner,
        SquareBtn,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        title: {
            type: String,
            default: 'PAYYO_SETTINGS.TERMINALS_TITLE',
        },
        icon: {
            type: String,
            default: 'fa-rectangle-list',
        },
        deviceId: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            loading: true,
            terminals: [],
            errorMessage: null,
        };
    },

    created() {
        try {
            container.payyoDriver.init(false);
            container.payyoDriver.getDevices()
                .then((data) => {
                    if (data.devices.length === 0) {
                        this.errorMessage = container.langService.getText('PAYYO_SETTINGS.NO_TERMINALS');
                    }
                    this.terminals = data.devices.sort((a, b) => {
                        return a.label > b.label ? 1 : -1;
                    });
                }).catch((error) => {
                    this.errorMessage = error.message;
                })
                .finally(() => {
                    this.loading = false;
                });
        } catch (error) {
            this.errorMessage = error.message;
            this.loading = false;
        }
    },

    methods: {
        async selectTerminal(deviceId) {
            container.dialogService
                .confirm('PAYYO_SETTINGS.TERMINALS_SELECT_CONFIRM')
                .then((confirmed) => {
                    if (confirmed) {
                        return this.resolve(deviceId);
                    }
                    // The user cancelled
                    return null;
                });
        },
    },
};
</script>

<style lang="less" scoped>
.payyo-terminals-list {
    td {
        // Keep the row heights consistent for the selected and unselected terminals.
        // Because this is a table cell height acts like min-height.
        height: 55px;
    }
}
</style>
